import { useSession } from '@playbooks/contexts';
import { AvatarImage } from '@playbooks/ui/components/avatar';
import { Button } from '@playbooks/ui/components/button';

const AccountSlideBtn = ({ account, accountType, open, onClick = undefined }) => {
	const session = useSession();

	// Render
	return (
		<Button variant='outline' size='icon' data-active={open} aria-label='account' onClick={onClick}>
			{accountType === 'collaborative' ? (
				<span className='inline-flex'>
					<AvatarImage
						className='w-4 h-4 border absolute bottom-0 right-0'
						src={account.thumbnail}
						alt={account.uuid}
					/>
					<AvatarImage className='w-6 h-6' src={session.user.thumbnail} alt={session.user.uuid} />
				</span>
			) : (
				<AvatarImage className='w-6 h-6' src={account.thumbnail} alt={account.uuid} />
			)}
		</Button>
	);
};

export { AccountSlideBtn };
